module.exports = __webpack_public_path__ + "img/volley.5129f93c.png";